<template>
  <div
    class="loading-overlay"
    v-bind:class="[loadingOverlayVisible ? 'visible': 'invisible']"
    :style="wrapperStyle"
  >
    <span class="loading-overlay-message">
      {{ loadingOverlayMessage }} <i class="fas fa-spinner fa-spin fa-fw"></i>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  computed: {
    ...mapState({
      loadingOverlayVisible: state => state.main.loadingOverlayVisible,
      loadingOverlayMessage: state => state.main.loadingOverlayMessage,
      marginBehindNavBar: state => state.main.marginBehindNavBar,
    }),
    wrapperStyle() {
      return `margin-left: ${this.marginBehindNavBar}px`;
    },
  },
};
</script>

<style scoped>
  .loading-overlay {
    font-family: "Work Sans", sans-serif;
    transition: ease-in-out 0.2s;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: rgba(255, 255, 255, 0.92);
  }

  .visible {
    visibility: visible;
    opacity: 1;
    z-index: 100;
  }

  .invisible {
    visibility: hidden;
    opacity: 0;
    z-index: -100;
  }

  .loading-overlay-message {
    font-family: "Work Sans", sans-serif;
    font-size: 14px;
    display: block;
    width: 350px;
    margin: 0 auto;
    margin-top: 25%;
    padding: 12px;
    color: #333;
    letter-spacing: 1px;
  }

  @media only screen and (max-width: 770px) {
    .loading-overlay-message {
      width: 85%;
    }
  }
</style>
